module.exports = __webpack_public_path__ + "img/pdf.e4ab2da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/advancedVersion/pdf.png
// module id = XsmX
// module chunks = 2 3 6 8 15 49